export function isValidPassword(p: string) {
    var hasNumber = /[0-9]+/;
    var hasUpperChar = /[A-Z]+/;
    var hasMiniMaxChars = /.{8,}/;
    var hasLowerChar = /[a-z]+/;
    //eslint-disable-next-line
    var hasSymbols = /[!@#$%^&*()_+=\[{\]};:<>|./?,-]/;
    return (
        p.length >= 8 &&
        hasNumber.test(p) &&
        hasUpperChar.test(p) &&
        hasMiniMaxChars.test(p) &&
        hasLowerChar.test(p) &&
        hasSymbols.test(p)
    );
}

export function isAtLeastMinimumLength(password: string) {
    return new RegExp(/(?=.{8,})/).test(password);
}

export function isAtLeastOneUppercaseLetter(password: string) {
    return new RegExp(/(?=.*?[A-Z])/).test(password);
}

export function isAtLeastOneLowercaseLetter(password: string) {
    return new RegExp(/(?=.*?[a-z])/).test(password);
}

export function isAtLeastOneNumber(password: string) {
    return new RegExp(/(?=.*?[0-9])/).test(password);
}

export const SPECIAL_CHARACTER_REGEX = /^(?!.*['"])(?=.*[^a-zA-Z0-9\s]).*$/;

export function isAtLeastOneSpecialChar(password: string) {
    return SPECIAL_CHARACTER_REGEX.test(password);
}

export const STRING_SPLIT_CHAR = "|";
class PasswordUtils {
    isPasswordValid = (password: string, confirmPassword: string) => {
        const isPasswordAtLeastMinimumLength = isAtLeastMinimumLength(password);
        const isPasswordAtLeastOneUppercaseLetter =
            isAtLeastOneUppercaseLetter(password);
        const isPasswordAtLeastOneLowercaseLetter =
            isAtLeastOneLowercaseLetter(password);
        const isPasswordAtLeastOneNumber = isAtLeastOneNumber(password);
        const isPasswordAtLeastOneSpecialChar =
            isAtLeastOneSpecialChar(password);

        const isPasswordMatching = password === confirmPassword;
        return (
            isPasswordMatching &&
            isPasswordAtLeastMinimumLength &&
            isPasswordAtLeastOneUppercaseLetter &&
            isPasswordAtLeastOneLowercaseLetter &&
            isPasswordAtLeastOneNumber &&
            isPasswordAtLeastOneSpecialChar
        );
    };
}

const passwordUtils = new PasswordUtils();

export default passwordUtils;
